import { render, staticRenderFns } from "./visual.vue?vue&type=template&id=3084c660&"
import script from "./visual.vue?vue&type=script&lang=js&"
export * from "./visual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports